const FALLBACK = {
    name: 'ProfileSuite',
    separator: '–',
    tagline: 'Print & Digital Cards, Bio Link, Landing Pages & Lead Capture',
    description: 'ProfileSuite – Print business cards, digital vCards, link-in-bio pages, landing pages, and lead capture tools. Built with Laravel.',
}

export function getSeoConfig() {
    if (typeof window !== 'undefined' && window.__APP_SEO__) {
        return { ...FALLBACK, ...window.__APP_SEO__ }
    }

    return FALLBACK
}

/**
 * Format document <title> per web convention: "Page – Site" or "Site – Tagline" for home.
 */
export function formatDocumentTitle(pageTitle, seo = getSeoConfig()) {
    const name = seo.name || FALLBACK.name
    const separator = seo.separator || FALLBACK.separator
    const tagline = seo.tagline || FALLBACK.tagline
    const normalized = (pageTitle || '').trim()

    if (!normalized || normalized === 'Home' || normalized === 'Card Information') {
        return `${name} ${separator} ${tagline}`
    }

    return `${normalized} ${separator} ${name}`
}

export function resolveMetaDescription(pageDescription, seo = getSeoConfig()) {
    const text = (pageDescription || '').trim() || seo.description || FALLBACK.description
    return truncateMeta(text, 160)
}

export function resolveOgTitle(pageTitle, seo = getSeoConfig()) {
    return formatDocumentTitle(pageTitle, seo)
}

function truncateMeta(text, maxLength) {
    if (text.length <= maxLength) {
        return text
    }

    const trimmed = text.slice(0, maxLength - 1)
    const lastSpace = trimmed.lastIndexOf(' ')

    if (lastSpace > maxLength * 0.6) {
        return `${trimmed.slice(0, lastSpace)}…`
    }

    return `${trimmed}…`
}
